module.exports = __webpack_public_path__ + "img/972.7258510e.png";